var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { Helmet } from 'react-helmet';
import { cleanWhite, paleGrey } from '../../../colors';
import Popup, { Theme } from '../../../popup';
import { getMaxColumns } from '../utils';
import { FlexContainer, Grid, HeaderNavigationSubmenu, RoundBorders, StyledArrowRight, SubmenuIcon, SubmenuItem, SubmenuItemDescription, SubmenuItemLink, SubmenuTitle, SubmenuBackground, SubmenuVerticalLink, SubmenuVerticalItem, ViewAllLink } from './Submenu.styles';

var Submenu = function Submenu(_a) {
  var navLink = _a.navLink,
      linkRefs = _a.linkRefs,
      linkComponent = _a.linkComponent,
      state = __rest(_a, ["navLink", "linkRefs", "linkComponent"]);

  var currentSubmenuOpen = state.headerSubmenu === navLink.id;
  /*
   * If submenu has at least 1 row with vertically displayed links
   * 1) the submenu will always have maximum columns = 2
   * 2) all submenu titles will have font 2.0rem instead of 2.5rem
   */

  var maxColumns = getMaxColumns(navLink);
  var submenuTitleRems = 2.5;

  if (navLink.submenuRows.some(function (row) {
    return row.linkDisplayType === 'verticalTitleOnly';
  })) {
    maxColumns = 1.5;
    submenuTitleRems = 2;
  }

  return /*#__PURE__*/React.createElement(Popup, {
    visible: currentSubmenuOpen,
    onClose: function onClose() {
      if (currentSubmenuOpen) {
        state.setHeaderSubmenu(null);
      }
    },
    enableBackground: true,
    ignoreRefs: linkRefs,
    theme: __assign(__assign({}, Theme), {
      Main: HeaderNavigationSubmenu,
      Background: SubmenuBackground
    }),
    maxColumns: maxColumns,
    "data-test": 'header-desktop-primary-submenu'
  }, /*#__PURE__*/React.createElement(React.Fragment, null, currentSubmenuOpen && /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("style", {
    type: 'text/css'
  }, "\n            body {\n              overflow: hidden;\n            }\n        ")), /*#__PURE__*/React.createElement(RoundBorders, null, navLink.submenuRows.map(function (row, i) {
    var _a, _b;

    return /*#__PURE__*/React.createElement(FlexContainer, {
      key: row.id,
      style: {
        // eslint-disable-next-line no-undef
        backgroundColor: i % 2 === 0 ? cleanWhite() : paleGrey(),
        borderTop: "1px " + (i % 2 === 0 ? cleanWhite() : '#e9eaea') + " solid"
      }
    }, /*#__PURE__*/React.createElement(SubmenuTitle, {
      submenuTitleRems: submenuTitleRems
    }, row.title), row.linkDisplayType === 'horizontalWithIconsDescription' ? /*#__PURE__*/React.createElement(Grid, {
      maxColumns: maxColumns
    }, row.submenuItems && row.submenuItems.map(function (item) {
      var _a;

      return /*#__PURE__*/React.createElement(SubmenuItem, {
        key: item.id,
        "data-test": 'header-desktop-submenu-item'
      }, /*#__PURE__*/React.createElement(SubmenuIcon, {
        src: currentSubmenuOpen && item.icon ? item.icon.url : '',
        alt: ((_a = item === null || item === void 0 ? void 0 : item.icon) === null || _a === void 0 ? void 0 : _a.alternativeText) || '',
        loading: 'lazy'
      }), /*#__PURE__*/React.createElement(SubmenuItemLink, {
        href: item.link,
        as: linkComponent,
        onClick: function onClick() {
          if (currentSubmenuOpen) {
            state.setHeaderSubmenu(null);
          }
        }
      }, item.title, /*#__PURE__*/React.createElement(StyledArrowRight, null)), /*#__PURE__*/React.createElement(SubmenuItemDescription, null, item.description));
    })) : /*#__PURE__*/React.createElement("ul", null, row.submenuItems && row.submenuItems.map(function (item) {
      return /*#__PURE__*/React.createElement(SubmenuVerticalItem, {
        key: item.id,
        "data-test": 'header-desktop-submenu-vertical-item'
      }, /*#__PURE__*/React.createElement(SubmenuVerticalLink, {
        href: item.link,
        as: linkComponent,
        onClick: function onClick() {
          if (currentSubmenuOpen) {
            state.setHeaderSubmenu(null);
          }
        }
      }, item.title));
    }), ((_a = row.viewAllLink) === null || _a === void 0 ? void 0 : _a.url) && row.viewAllLink.label ? /*#__PURE__*/React.createElement(ViewAllLink, {
      href: row.viewAllLink.url,
      as: linkComponent,
      onClick: function onClick() {
        if (currentSubmenuOpen) {
          state.setHeaderSubmenu(null);
        }
      }
    }, (_b = row.viewAllLink) === null || _b === void 0 ? void 0 : _b.label, /*#__PURE__*/React.createElement(StyledArrowRight, null)) : null));
  }))));
};

export default Submenu;